var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _path12, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyTaskList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 340,
    viewBox: "0 0 364 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9475 270.342C42.1733 261.234 40.8105 253.155 38.9475 242.117C36.6187 228.32 32.7374 197.341 52.4026 177.556C68.1346 161.728 86.0403 153.606 93.0266 151.523",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6094 269.965C79.7344 266.024 90.7944 248.888 89.3882 237.328C88.8822 234.039 89.2364 226.474 96.2192 222.527",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3047 192.543C77.6177 183.814 92.0388 172.429 103.424 170.532C114.809 168.634 115.816 176.374 114.348 179.66C112.146 184.589 107.353 190.037 97.7684 200.414C88.2728 210.694 83.0888 229.728 82.4844 238.808",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.468 161.825C253.089 155.493 234.739 144.286 220.364 150.115C219.062 150.636 216.354 153.082 215.938 158.703",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244.987 216.456C230.566 200.137 222.217 187.234 224.115 170.915C225.172 161.82 230.411 158.069 235.206 162.611C241.572 168.638 246.505 176.228 253.435 179.265C254.794 179.897 259.105 181.162 265.48 181.162",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297.954 252.907C297.26 250.131 295.819 241.249 296.652 234.17C297.694 225.323 296.751 191.927 282.168 182.299",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M295.833 164.839L205.984 158.37C205.836 158.359 205.681 158.375 205.538 158.414C191.83 162.185 197.731 169.765 202.549 173.701C202.748 173.864 202.992 173.96 203.249 173.983L223.728 175.845",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M295.454 183.058L265.461 181.092",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.298,
    cy: 173.912,
    rx: 7.96955,
    ry: 11.0056,
    fill: "#ACD9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M285.263 181.317C279.694 173.621 283.925 167.495 287.087 165.103C287.317 164.929 287.603 164.851 287.891 164.864L297.168 165.295C297.899 165.329 298.464 165.948 298.431 166.679L297.764 181.652C297.73 182.415 297.059 182.992 296.3 182.911L286.171 181.837C285.811 181.799 285.476 181.611 285.263 181.317Z",
    fill: "#ACD9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.277 163.272L196.354 161.661C197.269 161.37 198.18 162.118 198.072 163.072L197.589 167.368C197.482 168.321 196.43 168.848 195.603 168.364L191.009 165.679C190.017 165.1 190.182 163.619 191.277 163.272Z",
    fill: "#ACD9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9039 172.05L92.2695 71.8138C92.2691 57.0201 95.0214 31.9492 125.759 32.3645C156.496 32.7797 173.18 32.5375 177.68 32.3645",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M212.98 32.3652H264.642C278.921 32.6248 291.122 38.8536 291.122 62.7309C291.122 86.6081 290.416 136.523 289.377 162.564",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M246.115 286.282C224.827 287.839 167.896 291.988 133.542 293.459C119.003 293.459 99.7405 291.59 97.4561 265.429L95.8984 202.881",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195.116,
    cy: 20.5927,
    r: 10.1077,
    stroke: "#ACD9FF",
    strokeWidth: 3.31373
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.019 27.0192C180.882 32.4066 178.243 36.3436 172.294 37.6387C169.448 38.2581 165.465 38.3121 157.808 41.0058C148.238 44.3729 146.427 53.9565 146.168 62.2449C145.961 68.8757 149.79 71.0514 156.515 71.3104C176.088 71.2241 218.009 71.8284 229.201 71.8284C240.841 71.8284 242.534 67.4252 242.911 64.576C244.773 50.4857 239.807 44.8371 235.409 42.8189C233.34 41.8692 227.287 39.5036 219.63 37.6387C211.974 35.7739 210.595 33.2354 211.353 29.6092C213.215 20.6992 212.129 13.4641 211.353 10.9603C210.491 7.50681 205.455 0.910602 192.211 2.15387C175.656 3.70795 176.691 20.2848 179.019 27.0192Z",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M269.645 160.667L270.63 64.6532C270.63 62.5804 269.456 58.9531 264.67 58.9531C259.747 58.9531 248.69 59.1259 243.68 58.9531",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.952 58.9507H121.111C118.52 58.6916 113.544 60.1944 114.373 68.2781C115.203 76.3618 119.211 201.711 121.111 263.375C121.025 266.484 122.407 272.599 128.626 272.184C133.358 271.869 206.987 267.722 251.055 265.787",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M276.865 161.805L278.231 66.4347C278.231 63.579 276.987 59.4253 269.938 60.4637",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.508 59.6855C113.917 59.6855 107.956 59.6855 108.215 66.4351C108.464 72.922 110.807 139.348 111.584 170.155",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.582 185.076L113.914 266.074C114.174 268.929 115.21 273.083 127.65 272.045",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M141.605 103.707H190.182",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.926 120.939L246.799 120.42",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.184 138.332L224.473 137.553",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.983 165.345L183.467 163.513",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M279.895 163.701C277.997 167.243 273.823 172.05 278.377 181.158",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M219.559 205.902C217.029 208.914 215.613 217.517 230.185 227.84C237.396 232.52 252.348 246.739 254.474 266.17",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M215.759 175.467C214.403 178.009 213.808 182.902 218.036 187.59C220.119 189.899 223.373 192.159 228.282 194.062",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M218.035 187.588C215.322 191.512 212.849 199.559 219.553 205.898C221.29 207.54 227.057 210.585 230.179 211.897",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M270.744 332.586C262.648 313.737 251.314 272.928 270.744 260.48C295.032 244.921 326.531 280.215 337.537 310.575",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1992 317.78C25.0967 300.069 38.3034 263.923 60.7699 268.477C83.2365 273.031 89.3591 313.638 89.6121 333.372",
    stroke: "#ACD9FF",
    strokeWidth: 3.31373,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTaskList);
export default __webpack_public_path__ + "static/media/empty_task_list.e6c2af9fd29c586b763175bccd43396a.svg";
export { ForwardRef as ReactComponent };